import React, { useState, useEffect } from "react"
import sanityClient from "../client.js"
import Project from './Project.js'
import Video from './Video.js'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft, faArrowRight, faArrowUp, faArrowDown } from '@fortawesome/free-solid-svg-icons'

export default function Projects({ passedDownone, poop, lang }) {
  const [projectsData, setProjects] = useState(null)
  const [toggle, setToggle] = useState(true)
  const [openSections, setOpenSections] = useState({ ads: true, clips: true, film: true })

  useEffect(() => {
    sanityClient
      .fetch(`*[_type == "project"]{title, link, bgcolor, year, anchor, category, order}`)
      .then((data) => setProjects(data))
      .catch(console.error)
  }, [])

  function toggleSection(key) {
    setOpenSections(prev => ({ ...prev, [key]: !prev[key] }))
  }

  const labels = {
    ads:   lang === 'ENG' ? 'Ads'          : 'Comerciales',
    clips: lang === 'ENG' ? 'Music Videos' : 'Videoclips',
    film:  lang === 'ENG' ? 'Short Films'  : 'Cortometrajes',
  }

  const sorted = (cat) =>
    (projectsData || []).filter(p => p.category?.toLowerCase().includes(cat)).sort((a, b) => a.order > b.order ? 1 : -1)

  return (
    <div className="flex">
      <div className={`container${toggle ? '' : ' container--collapsed'}`}>
        <div onClick={() => setToggle(!toggle)} className="toggle">
          <FontAwesomeIcon icon={toggle ? faArrowLeft : faArrowRight} />
        </div>
        <div className={`menu${toggle ? '' : ' menu--hidden'}`}>
          {sorted('reel').map((p, i) => (
            <Project key={i} title={p.title} anchor={p.anchor} year={p.year} />
          ))}

          <div className="sec sec--collapsible" onClick={() => toggleSection('ads')}>
            {labels.ads}
            <FontAwesomeIcon icon={openSections.ads ? faArrowUp : faArrowDown} className="sec__arrow" />
          </div>
          {openSections.ads && sorted('ads').map((p, i) => (
            <Project key={i} title={p.title} anchor={p.anchor} year={p.year} />
          ))}

          <div className="sec sec--collapsible" onClick={() => toggleSection('clips')}>
            {labels.clips}
            <FontAwesomeIcon icon={openSections.clips ? faArrowUp : faArrowDown} className="sec__arrow" />
          </div>
          {openSections.clips && sorted('clips').map((p, i) => (
            <Project key={i} title={p.title} anchor={p.anchor} year={p.year} />
          ))}

          <div className="sec sec--collapsible" onClick={() => toggleSection('film')}>
            {labels.film}
            <FontAwesomeIcon icon={openSections.film ? faArrowUp : faArrowDown} className="sec__arrow" />
          </div>
          {openSections.film && sorted('film').map((p, i) => (
            <Project key={i} title={p.title} anchor={p.anchor} year={p.year} />
          ))}
        </div>
      </div>

      <div className={`content${toggle ? '' : ' content--expanded'}`}>
        <div className="option">
          {projectsData && [...projectsData]
            .sort((a, b) => a.order > b.order ? 1 : -1)
            .map((p, i) => (
              <Video
                key={i}
                title={p.title}
                link={p.link}
                anchor={p.anchor}
                bgcolor={p.bgcolor}
                passedDowntwo={passedDownone}
                sidebarOpen={toggle}
              />
            ))}
        </div>
      </div>
    </div>
  )
}
